import CardCarousal from './CardCarousal';
import StaticCard from './StaticCard';
import TopNavbar from './TopNavbar';
import Footer from './Footer';
import { Helmet } from "react-helmet-async";


const Home = () => {
    return (
        <>
            <Helmet>
                <title>Home - Easy Data Structures</title>
                <meta name="description" content="Discover Easy Data Structures — your platform for simplified data structures tutorials, coding guides, learning resources, and beginner-friendly DSA explanations." />
                <link rel="canonical" href="https://easydatastructures.com" />
                <script type="application/ld+json">{JSON.stringify(
                {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Easy Data Structures",
                "url": "https://easydatastructures.com/",
                "logo": "https://easydatastructures.com/easyDS-easydatastructures-logo.webp",
                "sameAs": [
                    "https://www.facebook.com/EasyDataStructures",
                    "https://www.instagram.com/easydatastructures",
                    "https://www.youtube.com/@visualhow",
                    "https://www.linkedin.com/company/easydatastructures",
                    "https://github.com/madanlal1",
                    "https://easydatastructures.com/"
                ]
                }
                )}
                </script>
                <script type="application/ld+json">{JSON.stringify(
                {
                "@context": "https://schema.org/",
                "@type": "Person",
                "name": "Madan Lal",
                "url": "https://madanlal1.github.io/Profile-Portfolio/",
                "image": "https://avatars.githubusercontent.com/u/81483460?v=4",
                "sameAs": [
                    "https://www.youtube.com/@visualhow",
                    "https://www.linkedin.com/company/easydatastructures",
                    "https://github.com/madanlal1",
                    "https://easydatastructures.com/"
                ]  
                }
                )}
                </script>
                <script type="application/ld+json">{JSON.stringify(
                {
                "@context": "https://schema.org/",
                "@type": "WebSite",
                "name": "Easy Data Structures",
                "url": "https://easydatastructures.com/",
                "potentialAction": {
                    "@type": "SearchAction",
                    "target": "https://easydatastructures.com/search?q=keyword{search_term_string}",
                    "query-input": "required name=search_term_string"
                }
                }
                )}
                </script>
                <script type="application/ld+json">{JSON.stringify(
                {
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What is Easy Data Structures?",
                        "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Easy Data Structures is an online platform that provides simple explanations, visuals, tutorials, and real-world examples of data structures and algorithms to help students and developers learn quickly."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Who can learn from Easy Data Structures?",
                        "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The website is designed for beginners, computer science students, job seekers preparing for technical interviews, and developers who want to refresh their knowledge of data structures."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Are the tutorials suitable for coding interview preparation?",
                        "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Yes, the tutorials and examples on Easy Data Structures cover the core concepts frequently asked in technical interviews, including arrays, linked lists, stacks, queues, trees, graphs, and algorithms."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Is Easy Data Structures free to use?",
                        "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Yes, all the explanations and learning material on Easy Data Structures are freely available for students and developers."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Which data structures can I learn on this website?",
                        "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "You can learn core data structures such as arrays, linked lists, stacks, queues, trees, heaps, hash tables, graphs, and more, along with visual examples and use cases."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Does Easy Data Structures offer real-world examples?",
                        "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Yes, each topic includes simple, real-world examples to help you understand how data structures are used in actual applications."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Can beginners understand the explanations easily?",
                        "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Absolutely. The content is written in simple language with diagrams and step-by-step explanations, making it ideal for beginners."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Do I need coding experience to start?",
                        "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "No prior coding experience is required. The website starts with the basics and gradually introduces you to more advanced concepts."
                        }
                    }
                    ]
                }
                )}
                </script>
            </Helmet>
            <TopNavbar/>
            <div className="container">
                {/* <CardCarousal/> */}
                <StaticCard/>
            </div>
            <Footer/>
        </> 
    )
}

export default Home;